import React from 'react';
import Navigation from '../components/Header';
import Form from '../components/Form';

const Home = () => {

    return (
        <div>
            <Navigation />
            <Form />
        </div>
    );
};

export default Home;